import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IGroupSFilter } from 'src/@types/SearchFilterTypes';
import { Page } from 'src/components/Page';

import GroupGrid from './GroupGrid';
import SearchForm from './SearchForm';

export const Group = observer(() => {
  // const pageTitle = 'INNERWAVE - GroupManagement';
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IGroupSFilter>>({});

  // 목록 검색
  const onSearch = (data: IGroupSFilter) => {
    setSearchData(data);
  };

  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <GroupGrid searchData={searchData} />
    </Page>
  );
});

export default Group;
